<!-- 面包屑 -->
<template>
  <div>
    <div class="container">
      <div class="content flex-sb">
        <div class="flex" style="align-items: center; padding-left: 20px">
          <span class="nav-txt pointer" @click="goToIndex(subBreadData.from)">
            {{
              subBreadData.from == 'index' ||
              subBreadData.from == 'goodProduct' ||
              subBreadData.from == 'packing'
                ? '全部结果'
                : '专属商城首页'
            }}
          </span>
          <i class="arrow-icon">></i>
          <div
            v-show="
              subBreadData.from == 'index' ||
              subBreadData.from == 'goodProduct' ||
              subBreadData.from == 'packing'
            "
            class="from-index"
          >
            <span
              v-for="item in subBreadData.list"
              v-show="
                subBreadData.from == 'index' && subBreadData.list.length > 0
              "
              :key="item.name"
              class="sel-btn pointer"
            >
              {{ item.name }}
              <i>
                <img
                  class="img"
                  src="~@/assets/img/purchase/icon-close-gray@2x.png"
                  alt=""
                />
                <img
                  class="img-hover"
                  src="~@/assets/img/purchase/icon-close-hover@2x.png"
                  alt=""
                  @click="removeSelectItem(item, false)"
                />
              </i>
            </span>
            <i
              v-show="
                subBreadData.from == 'index' && subBreadData.list.length > 0
              "
              class="arrow-icon"
            >
              >
            </i>
            <span class="ellipsis">{{ subBreadData.searchTxt }}</span>
          </div>
          <div v-show="subBreadData.from == 5" class="from-1">
            <p
              v-for="(sitem, sindex) in subBreadData.list"
              v-show="subBreadData.list.length > 0"
              :key="sitem.categoryId"
            >
              <span>{{ sitem.categoryName }}</span>
              <i
                v-show="sindex < subBreadData.list.length - 1"
                class="arrow-icon"
                >></i
              >
            </p>
            <span
              v-show="subBreadData.list.length == 0"
              style="color: #999; font-size: 14px"
            >
              {{ subBreadData.searchTxt }}
            </span>
          </div>
          <div v-show="subBreadData.from == 3" class="cate-brand">
            <span
              v-for="bitem in subBreadData.list.foreCategoryPathList"
              :key="bitem.categoryId"
            >
              {{ bitem.categoryName }}
              <i>></i>
            </span>
            <span>{{ subBreadData.searchTxt }}</span>
          </div>
          <div v-show="subBreadData.from == 4" class="from-4">
            <span>{{ subBreadData.searchTxt }}</span>
          </div>
          <div v-show="subBreadData.from == 2" class="from-4">
            <span>{{ subBreadData.searchTxt }}</span>
          </div>

          <span
            v-for="item in subBreadData.attrList"
            v-show="
              subBreadData.from != 'index' && subBreadData.attrList.length > 0
            "
            :key="item.name"
            style="margin: 0 10px"
            class="sel-btn pointer"
          >
            {{ item.name }}
            <i>
              <img
                class="img"
                src="~@/assets/img/purchase/icon-close-gray@2x.png"
                alt=""
              />
              <img
                class="img-hover"
                src="~@/assets/img/purchase/icon-close-hover@2x.png"
                alt=""
                @click="removeSelectItem(item, false)"
              />
            </i>
          </span>
        </div>
        <!-- <div class="select-wrap">
        <el-select class="select-wrap-select" v-model="value" placeholder="请选择" @change="selectSignAndAll">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
     </div>  -->
      </div>
      <!-- <div class="select-wrap">
        <el-select v-model="value" placeholder="请选择" @change="selectSignAndAll">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
     </div> -->
    </div>
    <div v-show="isMultBread" class="content">
      <ul class="mult-wrap">
        <li
          v-for="(multitem, index) in breadData.multiArrList"
          :key="'50' + index"
        >
          <span>{{ multitem.name }}：</span
          ><span v-for="submultitem in multitem.list" class="item">{{
            submultitem
          }}</span
          ><img
            src="../../../../assets/img/product/icon-close-color@2x.png"
            alt=""
            @click="removeSelectItem(multitem, true)"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    breadData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isMultBread: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      isHover: true,
      listLength: 0,
      attrListLength: 0,
      options: [
        { value: 1, label: '只看协议商品' },
        { value: 0, label: '查看全部商品' },
      ],
      value: null,
    };
  },

  computed: {
    subBreadData() {
      return this.breadData;
    },
  },

  created() {},
  mounted() {},
  methods: {
    removeSelectItem(val, isMult) {
      this.$emit('removeSelectItem', val, isMult);
    },
    goToIndex(from) {
      const pathArr = [
        '/demand/execute/selectGoods',
        '/plan/purchaseWayExecute/selectGoods',
      ];
      // 这两个页面点击不跳转
      if (pathArr.includes(this.$route.path)) {
        return false;
      }
      if (from != 'index') {
        this.$router.push({ path: '/' });
      }
    },
    selectSignAndAll(val) {
      console.log(val);
      this.$emit('selectSignAndAll', val);
    },
    // 获取length
    // getLength(){
    //   if(this.subBreadData.from == 'index'){
    //     this.listLength
    //   }
    // }
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin/flex.scss';
@import '@/assets/css/theme.scss';
.container {
  width: 100%;
  //   height: 46px;

  display: flex;
  .content {
    height: 44px;
    width: 100%;
    line-height: 44px;
    background: #f5f5f5;
    /*margin: 20px auto 10px auto;*/
    padding-left: 20px;
    .nav-txt {
      color: #999;
    }
    .arrow-icon {
      margin: 0 5px;
      color: #999;
    }
    .sel-btn {
      font-size: 12px;
      font-weight: 400;
      color: #666;
      border: 1px solid #d9d9d9;
      background: #fff;
      padding: 0 0 0 10px;
      line-height: 1;
      box-sizing: border-box;
      @include flex(center, center, row);
      margin-right: 10px;
      i {
        display: inline-block;
        height: 24px;
        width: 24px;
        background: #fff;
        line-height: 24px;
        text-align: center;
        margin-left: 5px;
        img {
          width: 10px;
          height: 10px;
        }
        .img-hover {
          display: none;
        }
      }

      &:hover {
        border: 1px solid $main-col;
        color: $main-col;
        i {
          display: inline-block;
          height: 24px;
          width: 24px;
          background: $main-col;
          line-height: 24px;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 10px;
            height: 10px;
          }
          .img {
            display: none;
          }
          .img-hover {
            display: block;
          }
        }
      }
    }
  }
  .from-index {
    display: flex;
    align-items: center;
    span {
      color: #999;
      display: inline-block;
      max-width: 350px;
    }
    i {
      color: #999;
    }
  }
}
.mult-wrap {
  display: flex;
  li {
    border: 1px dotted $main-col;
    color: #999;
    margin-right: 10px;
    padding: 6px;
    &:hover {
      color: $main-col;
    }
    img {
      width: 8px;
      height: 8px;
      margin-left: 6px;
      cursor: pointer;
    }
    .item {
      margin-right: 5px;
    }
  }
}
.from-1 {
  display: flex;
  font-size: 0;
  p {
    font-size: 0;
    span {
      font-size: 14px;
    }
    i {
      font-size: 14px;
    }
  }
}
.select-wrap {
  margin-right: 7px;
}
.select-wrap ::v-deep .el-input__inner {
  border-radius: 0;
  height: 30px;
  line-height: 30px;
}
.select-wrap-select ::v-deep .el-input {
  width: 180px;
  height: 30px;
  line-height: 30px;
  .el-select__caret {
    line-height: 30px;
  }
}
</style>
